exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-area-js": () => import("./../../../src/templates/area.js" /* webpackChunkName: "component---src-templates-area-js" */),
  "component---src-templates-doc-js": () => import("./../../../src/templates/doc.js" /* webpackChunkName: "component---src-templates-doc-js" */),
  "component---src-templates-language-js": () => import("./../../../src/templates/language.js" /* webpackChunkName: "component---src-templates-language-js" */),
  "component---src-templates-site-js": () => import("./../../../src/templates/site.js" /* webpackChunkName: "component---src-templates-site-js" */)
}

